/**
 * Free shipping bar driver.
 * Subscribes to Dawn's PUB_SUB_EVENTS.cartUpdate, fetches authoritative cart
 * state, updates every [data-shipping-bar] on the page, fires GA4 + Meta
 * milestone pixels, hydrates a "close the gap" recommendation, and plays a
 * celebration burst when the threshold is first crossed in a session.
 *
 * Idempotent across section re-renders: the wrapper guards against double-
 * binding, and bar elements are addressed via data attributes so any new
 * element re-rendered into the DOM is automatically picked up on next event.
 */
(function () {
  if (window.__htcCartProgressBound) return;
  window.__htcCartProgressBound = true;

  var milestonesFired = new Set();
  var lastTotalCents = null;
  var lastQualified = null;
  var inflightCartFetch = null;
  var gapCache = null;

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function $(sel, root) { return (root || document).querySelector(sel); }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fmtMoney(cents, symbol) {
    var sym = symbol || '$';
    var n = Math.max(0, cents) / 100;
    return sym + n.toFixed(n < 1000 ? 2 : 0);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function fetchCart() {
    if (inflightCartFetch) return inflightCartFetch;
    inflightCartFetch = fetch(rootUrl() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; })
      .then(function (data) { inflightCartFetch = null; return data; });
    return inflightCartFetch;
  }

  function looksLikeFullCart(obj) {
    return obj && typeof obj.total_price === 'number' && typeof obj.item_count === 'number' && Array.isArray(obj.items);
  }

  function fireMilestone(name, payload) {
    if (milestonesFired.has(name)) return;
    milestonesFired.add(name);
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload || {}));
    } catch (e) { /* swallow */ }
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', name.replace(/_([a-z])/g, function (_, c) { return c.toUpperCase(); }), payload || {});
      }
    } catch (e) { /* swallow */ }
  }

  function cartCurrency() {
    var bar = $('[data-shipping-bar]');
    return (bar && bar.getAttribute('data-currency-code')) || 'SGD';
  }

  function checkMilestones(totalCents, threshold) {
    if (totalCents <= 0) return;
    var pct = (totalCents * 100) / threshold;
    var currency = cartCurrency();
    var value = totalCents / 100;

    if (totalCents >= threshold) {
      fireMilestone('free_shipping_unlocked', {
        total_cents: totalCents,
        threshold_cents: threshold,
        value: value,
        currency: currency
      });
    }
    if (pct >= 75) fireMilestone('cart_progress_75_percent', { total_cents: totalCents, threshold_cents: threshold, value: value, currency: currency });
    if (pct >= 50) fireMilestone('cart_progress_50_percent', { total_cents: totalCents, threshold_cents: threshold, value: value, currency: currency });
    if (pct >= 25) fireMilestone('cart_progress_25_percent', { total_cents: totalCents, threshold_cents: threshold, value: value, currency: currency });
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function celebrate(bar) {
    if (reducedMotion()) return;
    var key = 'htc_confetti_fired';
    try {
      if (window.sessionStorage && window.sessionStorage.getItem(key) === '1') return;
      if (window.sessionStorage) window.sessionStorage.setItem(key, '1');
    } catch (e) { /* private mode */ }
    bar.classList.remove('htc-shipping-bar--celebrating');
    void bar.offsetWidth;
    bar.classList.add('htc-shipping-bar--celebrating');
    setTimeout(function () { bar.classList.remove('htc-shipping-bar--celebrating'); }, 1400);
  }

  function shieldSvg() {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="m9 12 2 2 4-4"></path></svg>';
  }

  function updateBar(bar, totalCents, itemCount) {
    var threshold = parseInt(bar.getAttribute('data-threshold-cents'), 10) || 5000;
    var symbol = bar.getAttribute('data-currency-symbol') || '$';
    var remaining = threshold - totalCents;
    var pct = Math.min(Math.round((totalCents * 100) / threshold), 100);
    var qualified = totalCents >= threshold;

    if (!itemCount || itemCount === 0) {
      bar.setAttribute('data-empty', 'true');
      return;
    }
    bar.removeAttribute('data-empty');
    bar.setAttribute('data-state', qualified ? 'qualified' : 'progress');

    var fill = $('[data-shipping-bar-fill]', bar);
    var text = $('[data-shipping-bar-text]', bar);
    var note = $('[data-shipping-bar-qualified-note]', bar);
    var gap = $('[data-shipping-bar-gap]', bar);

    if (fill) {
      fill.style.width = pct + '%';
      fill.className = 'htc-shipping-bar__fill ' + (qualified ? 'htc-shipping-bar__fill--complete' : 'htc-shipping-bar__fill--progress');
    }

    if (text) {
      if (qualified) {
        text.innerHTML = shieldSvg() + ' Free shipping unlocked';
        text.className = 'htc-shipping-bar__text htc-shipping-bar__qualified';
      } else {
        text.innerHTML = "You're <strong>" + escapeHtml(fmtMoney(remaining, symbol)) + "</strong> from free SG &amp; MY shipping";
        text.className = 'htc-shipping-bar__text';
      }
    }

    if (note) {
      note.hidden = !qualified;
    }

    if (gap) {
      if (qualified) {
        gap.hidden = true;
      } else {
        renderGapCard(bar, gap, remaining, symbol);
      }
    }

    if (qualified && lastQualified === false) {
      celebrate(bar);
    }

    checkMilestones(totalCents, threshold);
    lastTotalCents = totalCents;
    lastQualified = qualified;
  }

  function pickGapProduct(products, remainingCents) {
    if (!products || !products.length) return null;
    var fits = products.filter(function (p) {
      var price = p.variants && p.variants[0] && p.variants[0].price;
      return typeof price === 'number' && price >= remainingCents;
    });
    var pool = fits.length ? fits : products.slice();
    pool.sort(function (a, b) {
      var pa = (a.variants && a.variants[0] && a.variants[0].price) || 0;
      var pb = (b.variants && b.variants[0] && b.variants[0].price) || 0;
      return pa - pb;
    });
    return pool[0] || null;
  }

  function loadRecommendations(seedProductId, excludeIds) {
    var params = '?product_id=' + seedProductId + '&limit=10&intent=complementary';
    return fetch(rootUrl() + 'recommendations/products.json' + params)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = ((data && data.products) || []).filter(function (p) { return excludeIds.indexOf(p.id) === -1; });
        if (prods.length) return prods;
        return fetch(rootUrl() + 'recommendations/products.json?product_id=' + seedProductId + '&limit=10&intent=related')
          .then(function (r) { return r.json(); })
          .then(function (d2) { return ((d2 && d2.products) || []).filter(function (p) { return excludeIds.indexOf(p.id) === -1; }); });
      })
      .catch(function () { return []; });
  }

  function renderGapCard(bar, gap, remainingCents, symbol) {
    if (gap.__lastRemaining != null && Math.abs(gap.__lastRemaining - remainingCents) < 200 && gap.innerHTML.trim()) {
      gap.hidden = false;
      return;
    }

    fetchCart().then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) {
        gap.hidden = true;
        return;
      }
      var seedId = cart.items[0].product_id;
      var excludeIds = cart.items.map(function (it) { return it.product_id; });

      var poolPromise;
      if (gapCache && gapCache.seedId === seedId && gapCache.expires > Date.now()) {
        poolPromise = Promise.resolve(gapCache.products);
      } else {
        poolPromise = loadRecommendations(seedId, excludeIds).then(function (pool) {
          gapCache = { seedId: seedId, products: pool, expires: Date.now() + 60000 };
          return pool;
        });
      }

      poolPromise.then(function (pool) {
        var product = pickGapProduct(pool, remainingCents);
        if (!product) {
          gap.hidden = true;
          return;
        }
        var variant = product.variants && product.variants[0];
        var price = variant && variant.price;
        var imgUrl = product.featured_image || (product.images && product.images[0]) || '';
        if (typeof imgUrl === 'string' && imgUrl) {
          imgUrl = imgUrl.replace(/(\.[^./]+)(\?|$)/, '_88x88$1$2');
          if (imgUrl.indexOf('//') === 0) imgUrl = 'https:' + imgUrl;
        }
        var variantId = variant && variant.id;
        gap.innerHTML =
          '<div class="htc-shipping-bar__gap-card" data-shipping-bar-gap-card>' +
            (imgUrl ? '<a href="' + escapeHtml(product.url) + '" class="htc-shipping-bar__gap-img" tabindex="-1" aria-hidden="true"><img src="' + escapeHtml(imgUrl) + '" alt="" loading="lazy" width="44" height="44"></a>' : '') +
            '<div class="htc-shipping-bar__gap-body">' +
              '<span class="htc-shipping-bar__gap-eyebrow">Add to unlock free shipping</span>' +
              '<a href="' + escapeHtml(product.url) + '" class="htc-shipping-bar__gap-name">' + escapeHtml(product.title) + '</a>' +
              '<span class="htc-shipping-bar__gap-price">' + escapeHtml(fmtMoney(price || 0, symbol)) + '</span>' +
            '</div>' +
            (variantId ? '<button type="button" class="htc-shipping-bar__gap-add" data-variant-id="' + variantId + '" aria-label="Add ' + escapeHtml(product.title) + ' to cart">Add</button>' : '') +
          '</div>';
        gap.__lastRemaining = remainingCents;
        gap.hidden = false;

        var addBtn = $('.htc-shipping-bar__gap-add', gap);
        if (addBtn) addBtn.addEventListener('click', onGapAdd);
      });
    });
  }

  function onGapAdd(e) {
    var btn = e.currentTarget;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding';
    btn.classList.add('htc-shipping-bar__gap-add--loading');

    var sectionsToRender = [];
    var cartContainer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (cartContainer && typeof cartContainer.getSectionsToRender === 'function') {
      try { sectionsToRender = cartContainer.getSectionsToRender().map(function (s) { return s.id; }); } catch (_) { sectionsToRender = []; }
    }

    var body = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
    if (sectionsToRender.length) {
      body.sections = sectionsToRender.join(',');
      body.sections_url = window.location.pathname;
    }

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.textContent = 'Added';
        btn.classList.remove('htc-shipping-bar__gap-add--loading');
        btn.classList.add('htc-shipping-bar__gap-add--added');
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'cart_close_gap_add', variant_id: variantId });
        } catch (_) {}
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-progress-gap', cartData: data });
          }
        } catch (_) {}
        if (cartContainer && typeof cartContainer.renderContents === 'function' && data && data.sections) {
          cartContainer.renderContents(data);
        }
        refresh();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = origText;
        btn.classList.remove('htc-shipping-bar__gap-add--loading');
      });
  }

  function applyState(cart) {
    if (!cart) return;
    var bars = $$('[data-shipping-bar]');
    bars.forEach(function (bar) { updateBar(bar, cart.total_price || 0, cart.item_count || 0); });
  }

  function refresh() {
    return fetchCart().then(applyState);
  }

  function onCartUpdate(event) {
    if (event && looksLikeFullCart(event.cartData)) {
      applyState(event.cartData);
      return;
    }
    refresh();
  }

  function init() {
    refresh();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }

    document.addEventListener('cart:refresh', function () { refresh(); });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
